export default {
  lang: '中文',
  langCode: 'zh',
  toolbar: {
    expand: '展开工具栏',
    collapse: '收起工具栏',
  },
  input: {
    placeholder: '输入模型 URL 或拖拽文件到下方视图区域',
  },
  format: {
    auto: '自动检测',
  },
  btn: {
    add: '添加',
    clearAll: '清空全部',
    resetView: '恢复原点',
    exportHTML: '导出为 HTML',
    exportGLB: '导出含标注模型',
    exportAnnJSON: '导出标注 JSON',
    exportZip: '打包导出 (ZIP)',
    undo: '撤销',
    redo: '重做',
    split: '拆分',
    restore: '恢复',
    measure: '测量',
    annotate: '标注',
    clear: '清除',
    selectSplit: '选择拆分模型',
  },
  clip: {
    cut: '切割',
    xAxis: 'X 轴',
    yAxis: 'Y 轴',
    zAxis: 'Z 轴',
    section: '截面',
  },
  status: {
    idle: '就绪',
    loading: '正在加载模型...',
    cleared: '已清除全部',
    loadSuccess: '加载成功',
    loadFailed: '加载失败',
    unsupportedFormat: '仅支持 .stl / .obj / .ply / .gltf / .glb / .fbx / .step / .iges / .brep 格式',
    loadingFile: '正在加载',
    noSplitParts: '模型无可拆分的独立部分',
    splitDone: '拆分为 {count} 个独立部件',
    exporting: '正在导出...',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    annotationHint: '标注已添加，双击文字可编辑',
    noOriginalFile: '无法获取原始文件，仅支持拖拽导入的本地文件',
  },
  model: {
    vertices: '顶点',
    faces: '面',
    part: '部件',
  },
  material: {
    steel: '钢',
    stainless: '不锈钢',
    aluminum: '铝',
    titanium: '钛',
    copper: '铜',
    brass: '黄铜',
    cast_iron: '铸铁',
    zinc: '锌',
    nylon: '尼龙',
    abs: 'ABS',
    pla: 'PLA',
    pom: 'POM (聚甲醛)',
    acrylic: '亚克力',
    pc: '聚碳酸酯',
    oak: '橡木',
    pine: '松木',
    glass: '玻璃',
    ceramic: '陶瓷',
  },
  weight: {
    hollow: '空心',
    solid: '实心',
    thickness: '厚',
    mm: 'mm',
  },
  viewer: {
    leftView: '左视图',
    rightView: '右视图',
  },
  loading: {
    modelLoading: '加载模型中...',
    loadingPercent: '加载中 {percent}%',
  },
  dropHint: {
    text: '释放以加载模型文件 (.stl / .obj / .ply / .gltf / .glb / .fbx / .step / .iges / .brep)',
  },
  title: '3D Viewer',
}
